export function getErrorSignature(error: unknown): string {
  if (!error) {
    return ''
  }

  if (error instanceof Error) {
    return `${error.name}:${error.message}`
  }

  if (typeof error === 'object') {
    const value = error as { code?: unknown; message?: unknown }
    return `${String(value.code ?? '')}:${String(value.message ?? '')}`
  }

  return String(error)
}

export function getErrorMessage(error: unknown): string | undefined {
  if (!error) {
    return undefined
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'object') {
    const value = error as { message?: unknown }
    if (typeof value.message === 'string') {
      return value.message
    }
  }

  return String(error)
}
